import React from 'react'
import trendingtag from '../assets/homeWebp/Section2/trendingtag.png'

function CourseCard({ cardImg, title, price, courseLink, desc, cost, url, trending }) {

  return (
    <>
      <a href={courseLink} target="_blank" rel="noopener noreferrer">
        <div className='m-auto sm:m-0 relative 2xl:w-56 xl:w-60 w-88 min-w-[280px] sm:min-w-[250px] xl:min-w-[280px] 2xl:min-w-[310px] h-full min-h-[380px] sm:min-h-[350px] 2xl:min-h-[420px] bg-white text-left group rounded-md shadow-lg'>
          <div className='w-full h-full relative'>
            <img loading="lazy" decoding="async" className='w-full h-full object-contain rounded-t-md' src={cardImg} alt="" />
            {trending && (
              <div className='absolute top-6'>
                <img loading="lazy" decoding="async" className='w-28' src={trendingtag} alt="" />
              </div>
            )}
          </div>

          <div className='h-full w-full p-4 space-y-3'>
            <div className='flex justify-between'>
              {/* Removed category display */}
              <div
                className={`${price === 'FREE' ? 'text-green-500' : 'text-yellow-500'} font-medium text-lg 2xl:text-2xl 2xl:font-semibold`}
                style={{ fontSize: '15px' }}
              >
                {cost}
              </div>
            </div>

            <p className="font-medium w-full text-lg 2xl:text-2xl font-poppins tracking-tight mb-2">
              {title}
            </p>
            <p className="text-gray-700 2xl:text-[0.9rem] text-[0.9rem] font-poppins tracking-tight line-clamp-3">
              {desc}
            </p>

            <hr />

            <div className="flex justify-between">
              <div className="font-medium w-3/4 text-md 2xl:text-xl font-poppins tracking-tight">
                <button
                  className='bg-[#151595] text-white text-xs 2xl:text-base 2xl:px-1 px-2 py-1 rounded'
                  onClick={url}
                >
                  Know More
                </button>
              </div>
              <div className="font-medium justify-end 2xl:w-2/5 w-[100px] 2xl:px-0 xl:px-0 px-1 text-sm 2xl:text-base font-poppins tracking-tight"></div>
            </div>
          </div>
        </div>
      </a>
    </>
  )
}

export default CourseCard
